import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PlatiRidicariAutoComponent } from './plati-ridicari-auto.component';

const routes: Routes = [
    {
        path: '',
        component: PlatiRidicariAutoComponent,
        data: {
            title: 'Plati Online - Ridicari/Eliberari Auto'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PlatiRidicariAutoRoutingModule { }
